import React, { useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './Gallery.css';
import gallery1 from "../images/gallery/gallery-1.jpeg"
// import gallery2 from "../images/gallery/gallery-2.jpeg"
import gallery3 from "../images/gallery/gallery-3.jpeg"
import gallery4 from "../images/gallery/gallery-4.jpeg"
import gallery5 from "../images/gallery/gallery-5.jpeg"
import gallery6 from "../images/gallery/gallery-6.jpeg"
import gallery7 from "../images/gallery/gallery-7.jpeg"
// import gallery8 from "../images/gallery/gallery-8.jpeg"
// import gallery9 from "../images/gallery/gallery-9.jpeg"

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  const categories = [
    { id: 'all', name: 'All Projects' },
    { id: 'polishing', name: 'Marble & Granite Polishing' },
    { id: 'cleaning', name: 'Cleaning Services' },
    { id: 'renovation', name: 'Renovation' },
    { id: 'painting', name: 'Painting' },
    { id: 'carpentry', name: 'Carpentry' }
  ];

  const galleryImages = [
    { id: 1, category: 'polishing', title: 'Marble Polishing Project', image: gallery1 },
    // { id: 2, category: 'polishing', title: 'Granite Restoration', image:gallery2 },
    { id: 3, category: 'cleaning', title: 'Deep Cleaning Service', image: gallery3 },
    { id: 4, category: 'cleaning', title: 'Facade Glass Cleaning', image: gallery4 },
    { id: 5, category: 'renovation', title: 'Office Renovation', image: gallery5 },
    { id: 6, category: 'renovation', title: 'Home Renovation', image: gallery6 },
    { id: 7, category: 'painting', title: 'Wall Painting Project', image: gallery7 },
    // { id: 8, category: 'painting', title: 'Exterior Painting', image: gallery8 },
    // { id: 9, category: 'carpentry', title: 'Custom Furniture', image: '🪵' },
    // { id: 10, category: 'carpentry', title: 'Cabinet Installation', image: '🪵' },
    // { id: 11, category: 'polishing', title: 'Marble Floor Polishing', image: '🏗️' },
    // { id: 12, category: 'cleaning', title: 'Commercial Cleaning', image: '🧹' },
    // { id: 13, category: 'renovation', title: 'Kitchen Renovation', image: '🔨' },
    // { id: 14, category: 'painting', title: 'Interior Painting', image: '🎨' },
    // { id: 15, category: 'carpentry', title: 'Woodwork Project', image: '🪵' },
    // { id: 16, category: 'polishing', title: 'Granite Countertop', image: '🏗️' }
  ];

  const filteredImages = selectedCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    const currentIndex = filteredImages.findIndex(img => img.id === selectedImage.id);
    const nextIndex = (currentIndex + 1) % filteredImages.length;
    setSelectedImage(filteredImages[nextIndex]);
  };

  const prevImage = () => {
    const currentIndex = filteredImages.findIndex(img => img.id === selectedImage.id);
    const prevIndex = (currentIndex - 1 + filteredImages.length) % filteredImages.length;
    setSelectedImage(filteredImages[prevIndex]);
  };

  return (
    <div className="gallery-page">
      {/* Page Hero */}
      <section className="page-hero gallery-hero">
        <Container>
          <Row>
            <Col lg={12} className="text-center">
              <span className="page-badge">Our Gallery</span>
              <h1 className="page-title">Our Recent Projects</h1>
              <p className="page-description">
                Explore our portfolio of completed projects. We take pride in delivering 
                exceptional results for every client.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Category Filter */}
      {/* <section className="gallery-filter-section">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="category-filters">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
                    onClick={() => setSelectedCategory(category.id)}
                  >
                    {category.name}
                  </button>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}

      {/* Gallery Grid */}
      <section className="gallery-grid-section">
        <Container>
          <Row className="g-4">
            {filteredImages.map((image, index) => (
              <Col key={image.id} lg={4} md={6} sm={6}>
                <div 
                  className="gallery-item"
                  onClick={() => openModal(image)}
                >
                  <div className="gallery-image-wrapper">
                    <div className="gallery-image-placeholder">
                      <div className="gallery-icon">
                        <img src={image.image} alt={image?.title}/>
                      </div>
                      <div className="gallery-overlay">
                        <div className="gallery-info">
                          {/* <h4>{image.title}</h4> */}
                          <p>Click to view</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Image Modal */}
      <Modal 
        show={selectedImage !== null} 
        onHide={closeModal}
        centered
        size="lg"
        className="gallery-modal"
      >
        <Modal.Header className="gallery-modal-header">
          {/* <Modal.Title>{selectedImage?.title}</Modal.Title> */}
          <button className="modal-close-btn" onClick={closeModal}>
            <FaTimes />
          </button>
        </Modal.Header>
        <Modal.Body className="gallery-modal-body">
          <div className="modal-image-wrapper">
            <button className="modal-nav-btn prev-btn" onClick={prevImage}>
              <FaChevronLeft />
            </button>
            <div className="modal-image-placeholder">
              <div className="modal-icon"> <img className='w-100' src={selectedImage?.image} alt={selectedImage?.title}/></div>
              {/* <p>{selectedImage?.title}</p> */}
            </div>
            <button className="modal-nav-btn next-btn" onClick={nextImage}>
              <FaChevronRight />
            </button>
          </div>
          {/* <div className="modal-image-info">
            <p>Category: <strong>{categories.find(c => c.id === selectedImage?.category)?.name}</strong></p>
          </div> */}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Gallery;



